export const LEGAL_DOCUMENT_MAP = {
  PlanningAgreement: {
    name: 'planning-agreement',
    label: 'Planning Agreement',
    href: 'https://facet.com/legal-documents/planning-agreement/',
  },
  FormADVPart2A: {
    name: 'form-adv-part-2a',
    label: 'Form ADV Part 2A',
    href: 'https://facet.com/legal-documents/adv-part-2a/',
  },
  FormABVPart2B: {
    name: 'form-adv-part-2b',
    label: 'Form ADV Part 2B',
    href: 'https://facet.com/legal-documents/adv-part-2b/',
  },
  FormADVPart3: {
    name: 'form-adv-part-3',
    label: 'Form CRS',
    href: 'https://facet.com/legal-documents/adv-part-3/',
  },
  AdditionalDisclosures: {
    name: 'additional-disclosures',
    label: 'Additional Disclosures',
    href: 'https://facet.com/legal-documents/',
  },
};
